// Syncfusion v33's Fluent 2 theme is CSS-variable based: its dark palette
// is scoped to `.e-dark-mode` inside ej2-base/styles/fluent2.css — the
// packages ship no separate fluent2-dark.css. Mirror the suite's `.dark`
// (on <html>, set by @athavita/ui-theme) onto <body>, where Syncfusion also
// mounts its popups, so the ribbon, menus, dialogs, panes and grid headers
// follow the theme. Canvas-drawn content (document pages, cells) keeps the
// document's own colours. Identical file in Docs and Sheets.

let installed = false;

export function installSyncfusionDarkMode(): void {
    if (installed || typeof document === "undefined") return;
    installed = true;
    const root = document.documentElement;
    const sync = () => document.body.classList.toggle("e-dark-mode", root.classList.contains("dark"));
    sync();
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ["class"] });
}
